import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};
const dropzoneStyle = {
  minHeight: '70px',
  textAlign: 'center',
  borderStyle: 'dotted',
  borderWidth: '3px',
  borderRadius: '12px',
  padding: '2px'
};

/**
 * @typedef Props
 * @property {(e?: React.ChangeEvent<HTMLInputElement>) => void | undefined} onChange
 * @property {React.CSSProperties} style
 * @property {string | undefined} currentPhoto
 * @property {string | undefined} accept
 */

/**
 * @param {Props} props
 */
export default function Previews(props) {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      );
    }
  });

  const thumbs = files.map((file, index) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <Stack direction="column">
          <img src={file.preview} style={img} alt="" />
          <div className="text-center">{index ? 'Thumbnail' : 'File'}</div>
        </Stack>
      </div>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  function onChange(e) {
    const inputProps = getInputProps();
    if (inputProps.onChange) inputProps.onChange(e);
    if (props.onChange) props.onChange(e);
  }

  return (
    <section className="container" style={{ ...props.style, ...dropzoneStyle }}>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input
          {...{ ...props, ...getInputProps(), onChange: (e) => onChange(e) }}
          accept={props.accept ?? '*'}
        />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      <aside style={thumbsContainer}>
        <>{thumbs}</>
        {props.currentPhoto && !files.length && (
          <div style={thumb} key="Current photo">
            <div style={thumbInner}>
              <img src={props.currentPhoto} style={img} alt="could not to load !" />
            </div>
          </div>
        )}
      </aside>
    </section>
  );
}

Previews.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentPhoto: PropTypes.string,
  style: PropTypes.object,
  accept: PropTypes.string
};
